<template>
  <div v-if="loading">
    <div class="row">
      <div class="col-12">
        <label class="font28 font500">
          <i class="fas fa-comment-dots fa-13"></i> แก้ไขการส่งข้อความ
        </label>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-12">
        <!-- <div class="d-flex flex-row mr-5"> -->
        <div class="row">
          <div class="align-self-center ml-3">สถานะข้อความ</div>
          <div class="col-12 col-md-3">
            <select class="browser-default custom-select">
              <option selected>ทั้งหมด</option>
              <option value="1">ยังไม่ได้ส่ง</option>
              <option value="2">กำลังส่ง</option>
              <option value="3">ส่งเรียบร้อย</option>
              <option value="3">ยกเลิก</option>
            </select>
          </div>
          <div class="align-self-center ml-3">วัน / เวลา ที่ส่ง</div>
          <div class="col-12 col-md-3">
            <date-picker
              class="input-date"
              valuetype="format"
              type="datetime"
              lang="en"
              v-model="dateselect"
              @change="selectDate()"
            ></date-picker>
          </div>
        </div>

        <div class="row">
          <div class="align-self-center ml-3">เลือกการค้นหา</div>
          <div class="col-12 col-md-3 p-2">
            <select class="browser-default custom-select">
              <option selected>วันที่ส่ง</option>
              <option value="1">ข้อความ</option>
              <option value="2">จำนวนเครดิตที่ใช้</option>
              <option value="3">จำนวนหมายเลข</option>
            </select>
          </div>
          <div class="col-12 col-md-3 p-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon">
                  <mdb-icon far icon="edit" />
                </span>
              </div>
              <input
                type="text"
                class="form-control"
                aria-describedby="basic-addon"
                width="80%"
              />
            </div>
          </div>

          <div class="col-12 col-md-4 py-1">
            <button
              type="button"
              class="btn btn-search color_white font12"
              style="font-weight: 400; margin-left: -8px"
            >
              <i class="fab fa-sistrix"></i> Search
            </button>
            <button
              type="button"
              class="btn btn-cancel color_white font12"
              style="font-weight: 400"
            >
              <i class="fas fa-times"></i> Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <mdb-datatable
        :arrows="true"
        :data="data"
        striped
        bordered
        :searching="false"
        scrollY
        maxHeight="450px"
      />
    </div>
    <!-- <div class="border-detail mt-3">
			<div class="row">
				<div class="col-12">
					<div style="max-height:350px; overflow-y:auto; overflow-x:auto;">
						<div class="row justify-content-center text-center color_orange" style="min-width:1200px;">
							<span class="col py-3 pr-2" style="max-width:110px;  border-right: 0.5px solid #cccccc;">#</span>
							<span class="col py-3" style="max-width:160px; border-right: 0.5px solid #cccccc;">วันที่ตั้งส่ง</span>
							<span class="col py-3" style="max-width:160px; border-right: 0.5px solid #cccccc;">วันที่ส่ง</span>
							<span class="col py-3" style="border-right: 0.5px solid #cccccc;">ข้อความ</span>
							<span class="col py-3" style="max-width:130px; border-right: 0.5px solid #cccccc;">เครดิตที่ใช้</span>
							<span class="col py-3" style="max-width:130px; border-right: 0.5px solid #cccccc;">จำนวนเบอร์</span>
							<span class="col py-3" style="max-width:140px; border-right: 0.5px solid #cccccc;">แผนก</span>
							<span class="col py-3" style="min-width:165px; max-width:165px;"></span>
						</div>
						<div class="hr-horizontal mb-2"></div>
						<div class="row justify-content-center text-center font14" style="min-width:1200px; ">
							<span class="col pr-2" style="max-width:110px; border-right: 0.5px solid #cccccc;">1</span>
							<span class="col" style="max-width:160px; border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="max-width:160px; border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">ยูสใหม่โบนัส 50% เล่นเองรับค่าคอม 0.7%...</span>
							<span class="col" style="max-width:130px; border-right: 0.5px solid #cccccc;">250</span>
							<span class="col" style="max-width:130px; border-right: 0.5px solid #cccccc;">100</span>
							<span class="col" style="max-width:140px; border-right: 0.5px solid #cccccc;">Management</span>
							<span class="col" style="min-width:165px; max-width:165px;">
								<label class="btn-status-yellow text-white">กำลังส่ง</label>
								<span class="btn-edit text-white"><i class="fas fa-pen"></i></span>
								<span class="btn-delete text-white"><i class="fas fa-times"></i></span>
							</span>
						</div>
						<div class="row justify-content-center text-center font14" style="min-width:1200px; ">
							<span class="col pr-2" style="max-width:110px; border-right: 0.5px solid #cccccc;">2</span>
							<span class="col" style="max-width:160px; border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="max-width:160px; border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">ยูสใหม่โบนัส 50% เล่นเองรับค่าคอม 0.7%...</span>
							<span class="col" style="max-width:130px; border-right: 0.5px solid #cccccc;">250</span>
							<span class="col" style="max-width:130px; border-right: 0.5px solid #cccccc;">100</span>
							<span class="col" style="max-width:140px; border-right: 0.5px solid #cccccc;">Management</span>
							<span class="col" style="min-width:165px; max-width:165px;">
								<label class="btn-status-green text-white">ส่งแล้ว</label>
								<span class="btn-edit text-white"><i class="fas fa-pen"></i></span>
								<span class="btn-delete text-white"><i class="fas fa-times"></i></span>
							</span>
						</div>
						<div class="row justify-content-center text-center font14" style="min-width:1200px; ">
							<span class="col pr-2" style="max-width:110px; border-right: 0.5px solid #cccccc;">3</span>
							<span class="col" style="max-width:160px; border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="max-width:160px; border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">ยูสใหม่โบนัส 50% เล่นเองรับค่าคอม 0.7%...</span>
							<span class="col" style="max-width:130px; border-right: 0.5px solid #cccccc;">250</span>
							<span class="col" style="max-width:130px; border-right: 0.5px solid #cccccc;">100</span>
							<span class="col" style="max-width:140px; border-right: 0.5px solid #cccccc;">Management</span>
							<span class="col" style="min-width:165px; max-width:165px;">
								<label class="btn-status-blue text-white">ยังไม่ส่ง</label>
								<span class="btn-edit text-white"><i class="fas fa-pen"></i></span>
								<span class="btn-delete text-white"><i class="fas fa-times"></i></span>
							</span>
						</div>
						<div class="row justify-content-center text-center font14" style="min-width:1200px; ">
							<span class="col pr-2" style="max-width:110px; border-right: 0.5px solid #cccccc;">4</span>
							<span class="col" style="max-width:160px; border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="max-width:160px; border-right: 0.5px solid #cccccc;">20/10/2020 15:50</span>
							<span class="col" style="border-right: 0.5px solid #cccccc;">ยูสใหม่โบนัส 50% เล่นเองรับค่าคอม 0.7%...</span>
							<span class="col" style="max-width:130px; border-right: 0.5px solid #cccccc;">250</span>
							<span class="col" style="max-width:130px; border-right: 0.5px solid #cccccc;">100</span>
							<span class="col" style="max-width:140px; border-right: 0.5px solid #cccccc;">Management</span>
							<span class="col" style="min-width:165px; max-width:165px;">
								<label class="btn-status-red text-white">ยกเลิก</label>
								<span class="btn-edit text-white"><i class="fas fa-pen"></i></span>
								<span class="btn-delete text-white"><i class="fas fa-times"></i></span>
							</span>
						</div>
					</div>
				</div>
			</div>
    </div>-->
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import moment from "moment";
let no = 0;
export default {
  name: "EditSendmessage",
  components: {
    DatePicker,
  },
  data() {
    return {
      dateselect: new Date(),
      loading: false,
      data: {
        columns: [
          {
            label: "#",
            field: "id2",
            sort: true,
            format: (value) => {
              no = value - 1;
              return value;
            },
          },
          {
            label: "วันที่ตั้งส่ง",
            field: "date_set",
            sort: true,
            format: (value) => {
              return moment(value).format("DD/MM/YYYY HH:mm:ss");
            },
          },
          {
            label: "วันที่ส่ง",
            field: "date_send",
            sort: true,
            format: (value) => {
              return moment(value).format("DD/MM/YYYY HH:mm:ss");
            },
          },
          {
            label: "ข้อความ",
            field: "message",
            sort: true,
            format: (value) => {
              if (value) {
                return (
                  '<label class="norwarp" title="' +
                  value +
                  '" >' +
                  value +
                  "</label>"
                );
              }
            },
          },
          {
            label: "เครดิตที่ใช้",
            field: "use_credit",
            sort: true,
          },
          {
            label: "จำนวนเบอร์",
            field: "amount_phone",
            sort: true,
          },
          // {
          // 	label: 'แผนก',
          // 	field: 'sender',
          // 	sort: true,
          // },
          {
            label: "",
            field: "status",
            format: (value) => {
              if (
                value == 1 &&
                moment(this.data.rows[no].date_set).format("YYYYMMDDHHmmss") <=
                  moment(new Date()).format("YYYYMMDDHHmmss")
              ) {
                return '<div class="rows text-center font500" style="min-width:140px;"><span class="btn-status-green text-white">ส่งแล้ว</span><span class="btn-edit-disabled text-white"><i class="fas fa-pen"></i></span><span class="btn-delete-disabled text-white"><i class="fas fa-times"></i></span></div>';
              } else {
                return (
                  '<div class="rows text-center font500" style="min-width:140px;"><span class="btn-status-red text-white" style="padding-left:12px; padding-right:12px;">ยังไม่ส่ง</span><a href="/EditSendmessagelist?edit=' +
                  this.data.rows[no].id +
                  '"><span class="btn-edit text-white"><i class="fas fa-pen"></i></span></a><span class="btn-delete text-white btnbtn" dataid="' +
                  this.data.rows[no].id +
                  '" ><i class="fas fa-times"></i></span></div>'
                );
              }
            },
          },
        ],
        rows: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      token: "token",
    }),
  },
  methods: {
    clickCallback: function (pageNum) {
      console.log(pageNum);
    },
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      callApiMotherFucker: "callApiMotherFucker",
    }),
    search() {
      this.search = this.res.payload;
    },
  },
  async mounted() {
    this.dateselect = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    await this.callApiMotherFucker({
      method: "post",
      path: "/message/All",
      data: {},
    }).then((res) => {
      this.loading = true;
      if (res.payload) {
        this.data.rows = this.$add_index(res.payload);
      }
    });
    let ieieieiei = this;
    $(".btnbtn").on("click", function () {
      let id = $(this).attr("dataid") || 0;
      if (id > 0) {
        this.loading = false;
        let payload = {
          id: id, //this.data.rows.id_upload_file,
        };
        ieieieiei
          .callApiMotherFucker({
            method: "delete",
            path: "/message",
            data: payload,
          })
          .then((res) => {
            ieieieiei.$swal({
              icon: "success",
              html: res.msg,
              timer: 8000,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
            setTimeout(() => {
              location.reload();
            }, 2000);
          });
      }
    });
  },
};
</script>
